import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function QualificationSection({ formData, handleChange, isEdit }) {
  return (
    <>
      {/* Budget Range */}
      <div>
        <Label>Budget Range</Label>
        <div className="flex gap-3 mt-1">
          <Input type="number" name="budget_min" value={formData.budget_min} onChange={handleChange} placeholder="Min Budget" className="h-11 rounded-sm flex-1" data-testid="lead-budget-min" />
          <span className="flex items-center text-slate-400">to</span>
          <Input type="number" name="budget_max" value={formData.budget_max} onChange={handleChange} placeholder="Max Budget" className="h-11 rounded-sm flex-1" data-testid="lead-budget-max" />
        </div>
      </div>

      {/* Location & Property Preferences */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <Label htmlFor="preferred_location">Preferred Location</Label>
          <Input id="preferred_location" name="preferred_location" value={formData.preferred_location} onChange={handleChange} placeholder="e.g. Baner, Wakad" className="mt-1 h-11 rounded-sm" />
        </div>
        <div>
          <Label htmlFor="property_type_preference">Property Type</Label>
          <select id="property_type_preference" name="property_type_preference" value={formData.property_type_preference} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
            <option value="">Select</option>
            <option value="residential">Residential</option>
            <option value="commercial">Commercial</option>
            <option value="land">Land</option>
          </select>
        </div>
        <div>
          <Label htmlFor="bhk_preference">BHK Preference</Label>
          <select id="bhk_preference" name="bhk_preference" value={formData.bhk_preference} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
            <option value="">Select</option>
            <option value="1BHK">1 BHK</option>
            <option value="2BHK">2 BHK</option>
            <option value="3BHK">3 BHK</option>
            <option value="4BHK+">4 BHK+</option>
          </select>
        </div>
      </div>

      {/* Requirement Qualification - shown when editing */}
      {isEdit && (
        <div className="border-t pt-6">
          <h3 className="text-lg font-semibold text-slate-800 mb-4">Requirement Qualification</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <Label>Investment or Self-Use</Label>
              <select name="investment_or_selfuse" value={formData.investment_or_selfuse} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
                <option value="">Select</option>
                <option value="investment">Investment</option>
                <option value="self_use">Self Use</option>
              </select>
            </div>
            <div>
              <Label>Timeline to Purchase</Label>
              <select name="timeline_to_purchase" value={formData.timeline_to_purchase} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
                <option value="">Select</option>
                <option value="immediate">Immediate</option>
                <option value="1_3_months">1-3 Months</option>
                <option value="3_6_months">3-6 Months</option>
                <option value="6_12_months">6-12 Months</option>
                <option value="12_plus_months">12+ Months</option>
              </select>
            </div>
            <div>
              <Label>Family Size</Label>
              <Input name="family_size" value={formData.family_size} onChange={handleChange} placeholder="e.g. 4 members" className="mt-1 h-11 rounded-sm" />
            </div>
            <div>
              <Label>Financing</Label>
              <select name="financing" value={formData.financing} onChange={handleChange} className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm">
                <option value="">Select</option>
                <option value="loan">Home Loan</option>
                <option value="self_funded">Self Funded</option>
                <option value="both">Both</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
